export default function () {
    const badgeCaseData = [
        {
            company: {
                companyId: 1,
                logoUrl: require('@/assets/png/badgeCompany/company-1/company-logo.png'),
                name: 'Horng Gee Co., Ltd. ',
                introduction:
                    'Established in 1980, Horng Gee has over 40 years of experience and the expertise in handling recycled plastics. From 700 tons in the start-up period, the Company is now capable to handle over 50,000 tons of recycled plastics effectively. Its business scope, on the other hand, has also been extended to the trading of virgin and recycled PP, PE, ABS, PS, PC and PET (yarn and sheet) plastics. \n\
                    In recent years, waste debris has become a significant issue. Being a professional recycling and reuse company, Horng Gee started to develop a solution for reclaiming marine debris (ex. including fishing nets, fishing buoys, Styrofoam, cans, bottles and plastics) that are hard to handle in 2019.\n\
                    After entering Horng Gee’s plastic reclamation plant, recycled marine debris should pass the quality inspection first and then be washed, classified and melted to produce 100% recycled marine debris plastic pellets. \n\
                    The certified recycled marine debris plastic materials include PP, PE, PA, ABS and PS.\n\
                    Moreover, concerning the different characteristics of plastics, Horng Gee has developed various applications of reclaimed materials (ex., blown film, blow molding, extrusion and injection) based on the characteristics of different plastics; and provides customized ingredients and dyeing services accordingly.\n\
                    In terms of quality, 90% of Horng Gee’s reclaimed plastic materials can compete with virgin plastics. These materials can also be applied in all types of bottles and cans; household products; building materials; electronic products; office supplies; automobile parts and components; sports equipment; and so on.\n\
                    Oriented to our initial intention of being “honest, practical, responsible and innovative”, Horng Gee not only insists on doing the right thing in every detail to contribute to the earth’s wellbeing, but also fully promotes circular economy to give reclaimed plastic materials an even higher value.',
            },
            cases: [
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-1/case-1/product-1.jpeg'),
                            name: 'Marine debris recycled PP plastic materials',
                            wasteProportion: 100,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-1/case-1/product-2.jpeg'),
                            name: 'Marine debris recycled PE plastic materials',
                            wasteProportion: 100,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-1/case-1/product-3.jpeg'),
                            name: 'Marine debris recycled PA plastic materials',
                            wasteProportion: 100,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-1/case-1/product-4.jpeg'),
                            name: 'Marine debris recycled ABS plastic materials',
                            wasteProportion: 100,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-1/case-1/product-5.jpeg'),
                            name: 'Marine debris recycled PS plastic materials',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 2,
                logoUrl: require('@/assets/png/badgeCompany/company-2/company-logo.png'),
                name: 'Boretech Resource Recovery Technology Co., Ltd. (BoReTech Co., Ltd.)',
                introduction:
                    'After the establishment of its first polyester reclamation plant in Taiwan in 1991. BoReTech Co., Ltd. already accumulated over 20 years of experiences in the recycling and reclamation of other plastic materials and bottles; and 15 years of experience in the production of polyester staple fibers. Over the years, BoReTech Co., Ltd. has been devoted to developing plastic recycling technology and the comprehensive use of reclaimed materials, with the aspiration to become a “resource and technology integrator in the reclaimed polyester industrial chain”.\n\
                    Our abundant production experience is the backbone of planning, designing and manufacturing plastic recycling system. It is especially so in the recycling and reclamation of PET bottles. We do not only provide turn-key transfer and single equipment technology, but also engage in the production and sale of various reclaimed PET and PP materials as well as upstream and downstream products.',
            },
            cases: [
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-2/case-1/product-1.jpeg'),
                            name: 'Marine debris recycled PET bottle flakes',
                            wasteProportion: 100,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-2/case-1/product-2.jpeg'),
                            name: 'Marine debris recycled PET bottle pellets',
                            wasteProportion: 50,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-2/case-1/product-3.jpeg'),
                            name: 'Marine debris recycled PP bottle flakes',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 3,
                logoUrl: require('@/assets/png/badgeCompany/company-3/company-logo.png'),
                name: 'Taijei Precision CO., Ltd.',
                introduction:
                    'With the adoption of BoReTech’s reclaimed marine debris PET plastic pellets, Taijei Precision Co., Ltd. has mixed the pellets with agricultural and fishing wastes (i.e., rice husk and oyster shell powder) to create new pellets. The new reclaimed pellets have also been submitted to the competent authority for the use of the recycled marine debris product label; and then be used to make building materials (plank, wood plastic composite/ plastic wood support and semi-finished floor). In total, Taijei has obtained the label for 4 products.',
            },
            cases: [
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-1/product-1.png'),
                            name: 'Taijei PET pellet',
                            wasteProportion: 25,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-1/product-2.png'),
                            name: 'Plank (PET)',
                            wasteProportion: 21.93,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-1/product-3.png'),
                            name: 'Wood plastic composite/ plastic wood support (PET)',
                            wasteProportion: 21.93,
                        },
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-3/case-1/product-4.png'),
                            name: 'Semi-finished floor',
                            wasteProportion: 21.67,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 4,
                logoUrl: require('@/assets/png/badgeCompany/company-4/company-logo.png'),
                name: 'Nice Enterprise Co., Ltd.',
                introduction:
                    'Nice Enterprise Co., Ltd. purchases 100% marine debris recycled PE plastic pellets certified by EPA with a label from Horng Gee Co., Ltd. Then, based on the physical property requirements of final product, it then send the mixture of marine debris recycled PE plastic pellets (26%) and post-consumer recycled resin (74%) to Living Fountain Plastic Industrial Co., Ltd. for plastic hollow blow molding.\n\
                    The finished products are given to Nice Enterprise Co,. Ltd. to fill in Baigo bleaching and disinfectant powder. Ocean is rich in NaCl (salt), an ingredient required by human body. As for normal saline, it can produce sodium hydroxide (NaOH) during the electrolysis process. When NaOH reacts with carbon dioxide (CO2), sodium carbonate (Na2CO3) or sodium bicarbonate (NaHCO3) will be produced.\n\
                    When Na2Co3 reacts with hydrogen peroxide (H2O2, i.e. hydrogen peroxide), sodium percarbonate (SPC) will be produced. SPC can be used as a laundry auxiliary with the oxidizing bleaching effect. Baigo Bleaching and Disinfectant Powder (contains rich SPC) is an extremely eco-friendly detergent from the ocean with an excellent cleaning and sterilization performance.\n\
                    Plus the new container (bottle) made of 100% reclaimed plastic material, Baigo Bleaching and Disinfectant Powder is now a good, natural and eco-friendly product from the inside out. ',
            },
            cases: [
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-4/case-1/product-1.jpeg'),
                            name: 'Bottle of “Baigo Bleaching and Disinfectant Powder”',
                            wasteProportion: 26,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 5,
                logoUrl: require('@/assets/png/badgeCompany/company-5/company-logo.png'),
                name: 'Poseidon Global Industries Co., Ltd.',
                introduction:
                    'At Poseidon Industry, we specialize in chemical recycling plastic via pyrolysis. Through pyrolysis, we chemically transform plastic waste into pyrolysis oil, which can be further refined into naphtha or used as fuel oils and other applications. This is a great solution for reducing plastic waste throughout the world. Though the technology of plastic pyrolysis has existed for years, we at Poseidon Industry are one of the premier companies who are chemical recycling and transforming plastic waste into pyrolysis oil using environmentally friendly, consistent, and efficient processes.\n\
                    Poseidon Industry’s PSD Renewable Carbon Black is made of 100% renewable materials.  The nets are sourced from government verified fisheries, and the waste plastic is pre-consumer plastic recyclables.  The PSD renewable carbon black has a wide range of uses, from carbon steel to paved roads as well as coloring.  Choosing to use this product will help reduce ocean plastic and encourage more companies and government agencies to participate in activities and projects to collect and reduce ocean waste.  This will encourage ocean waste recycling in Taiwan and lead the world!',
            },
            cases: [
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-5/case-1/product-1.jpeg'),
                            name: 'Poseidon Industry’s PSD Renewable Carbon Black',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 6,
                logoUrl: require('@/assets/png/badgeCompany/company-6/company-logo.png'),
                name: 'GREENVINES BIOTECH CO., LTD.',
                introduction:
                    'About Greenvines\n\
                    \n\
                    Greenvines is a clean skincare brand on a mission to transform skin rituals into sustainable outcomes. We replace 2900+ unnecessary ingredients from our formula with natural and new specially created alternatives that work smarter. With a limited collection of 22 products ranging from cleansing to skincare, we aim to challenge conventional skincare practice by  creating a simpler skincare routine for good. For five consecutive rounds, we are also the only in Asia recognized as a “Best For The World” B Corp for environmental excellence.\n\
                    \n\
                    \n\
                    Scalp Clarifying Shampoo - 33% Recycled Marine Debris Bottle \n\
                    \n\
                    At the beginning of 2022, Greenvines started a challenge, hoping to tackle the marine waste issue in Taiwan by having more Taiwanese abandoned fishing nets back in the recycling system. \n\
                    \n\
                    After 6 months of effort, and in collaboration with 5 supply chain partners, Greenvines finally gave 1,800 kilos of recycled fishing nets collected from Wuqi Port, Taichung a second life.\n\
                    \n\
                    Not only is the Scalp Clarifying Shampoo - Marine Debris Reviving Bottle made from 100% post recycled plastic, which includes 33% marine debris, it also received the “Recycled Marine Debris Product Label” certified by the Taiwanese Environmental Protection Agency in October. Thus, Taiwan’s very first recycled marine debris shampoo bottle was born.',
            },
            cases: [
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-6/case-1/product-1.jpeg'),
                            name: 'Scalp Clarifying Shampoo - Marine Debris Reviving Bottle',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
        {
            company: {
                companyId: 7,
                logoUrl: require('@/assets/png/badgeCompany/company-7/company-logo.png'),
                name: 'Global Green Materials',
                introduction:
                    "Global Green Materials is a company specializing in the production of post-consumer recycled plastic pellets and ocean-bound recycled plastic pellets. We also offer material compounding and coloring services. Our journey began in a plastic container recycling plant, allowing us to provide long-term, stable post-consumer raw materials. Through professional sorting, cleaning, and color sorting techniques, we produce high-quality, low-odor, and light-colored recycled plastic pellets. Our PCR products are GRS traceability certified, TÜV product carbon footprint certified, and TÜV traceability certified. Additionally, they have passed the REACH, ROHS, and FDA 21 CFR conducted by third-party testing companies. Our ability to customize PCR materials and provide comprehensive solutions for our customers' material requirements is our greatest feature and advantage.",
            },
            cases: [
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-1/product-1.jpg'),
                            name: 'Recycled Marine Waste Fishing Net HDPE Pellet',
                            wasteProportion: 100,
                        },
                    ],
                },
                {
                    products: [
                        {
                            imgUrl: require('@/assets/png/badgeCompany/company-7/case-2/product-1.jpg'),
                            name: 'Recycled Marine Waste Styrofoam PS Pellet',
                            wasteProportion: 100,
                        },
                    ],
                },
            ],
        },
    ]
    return { badgeCaseData }
}
